export enum FiltersPayloadStatus {
  Initial = 'initial',
  Normal = 'normal',
}
